import { ActionReducerMap } from '@ngrx/store';
import { excelConnectorListReducer } from './excel-connector-list.reducers';
import { pendingChangesReducer } from 'app/core/store/reducers/pending-changes.reducers';
import { excelConnectorCurrentReducer } from './excel-connector-current.reducers';

export const MANAGE_EXCEL_CONNECTOR_REDUCER: ActionReducerMap<IExcelConnectorState> = {
    excelConnectorList: excelConnectorListReducer,
    pendingChangesExcelConnector : pendingChangesReducer,
    excelConnectorCurrent : excelConnectorCurrentReducer
};